<template>
  <div class="d-flex align-items-center justify-content-center py-5">
    <b-spinner
      variant="primary"
      class="mr-1"
    />
    <span>Loading dashboard...</span>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
    components: {
        BSpinner,
    },
    created() {
        const targetRoute = getHomeRouteForLoggedInUser()

        if (targetRoute.name === this.$route.name) {
            this.$router.replace({ name: 'dashboard-overview' })
            return
        }

        this.$router.replace(targetRoute)
    },
}
</script>
